import * as actionTypes from "./actionTypes";
import * as types from "./types";

//DB Extractor
const initEventTriggerState: types.IEventTriggersState = {
    pending: false,
    trigger: null,
    error: null,
  };
  
  export const EventTriggerReducer = (state = initEventTriggerState, action: types.PostEventTriggerActions) => {
    switch (action.type) {
      case actionTypes.POST_EVENTTRIGGERS_REQUEST:
        return {
          ...state,
          pending: true,
        };
      case actionTypes.POST_EVENTTRIGGERS_SUCCESS:
        return {
          ...state,
          pending: false,
          trigger: action.payload.trigger,
          error: null,
        };
      case actionTypes.POST_EVENTTRIGERRS_FAILURE:
        return {
          ...state,
          pending: false,
          trigger: null,
          error: action.payload.error,
        };
      default:
        return {
          ...state,
        };
    }
  };

  //Put Events extractor
const initialPutStateEvents: types.IPutEventsState = {
    pending: false,
    eventsStatus: null,
    error: null,
};

export const PutEventsReducer = (state = initialPutStateEvents, action: types.PutEventActions) => {
    switch (action.type) {
        case actionTypes.PUT_EVENTTRIGGERS_REQUEST:
            return {
                ...state,
                pending: true,
            };
        case actionTypes.PUT_EVENTTRIGGERS_SUCCESS:
            return {
                ...state,
                pending: false,
                eventsStatus: action.payload.eventsStatus,
                error: null,
            };
        case actionTypes.PUT_EVENTTRIGGERS_FAILURE:
            return {
                ...state,
                pending: false,
                eventsStatus: null,
                error: action.payload.error,
            };
        default:
            return {
                ...state,
            };
    }
};

// DELETE Event Details Details

const initDeleteEventsState: types.IDeleteEventsState = {
    pending: false,
    success: null,
    error: null,
};

export const DeleteEventsReducer = (state = initDeleteEventsState, action: types.DeleteEventsActions) => {
    switch (action.type) {
        case actionTypes.DELETE_EVENTTRIGGERS_REQUEST:
            return {
                ...state,
                success: null,
                pending: true,
            };
        case actionTypes.DELETE_EVENTTRIGGERS_SUCCESS:
            return {
                ...state,
                pending: false,
                success: action.success,
                error: null,
            };
        case actionTypes.DELETE_EVENTTRIGGERS_FAILURE:
            return {
                ...state,
                pending: false,
                success: null,
                error: action.payload.error,
            };
        default:
            return {
                ...state,
            };
    }
};